goog.provide('el8.appchart.dialog.changeDocumentSubType');

goog.require('el8.data.reportTypes');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appchart.dialog.changeReportCategory');


/**
 * Used for things that are technically not reports that are pretending
 * to be reports (like imported notes). Could also be used for future
 * models that have document_sub_types for reasons besides holding
 * report categories. Reports use editReportDetails to edit the report
 * caregory together with other fields, like custom title and tags.
 */
el8.appchart.dialog.changeDocumentSubType = (function() {

    var doc = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Select new report category...',
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.appchart.dialog.changeReportCategory.content();
        }
    });
    var form = new el8.uiwidget.Form({
        fields: [{
            name: 'reportType'
        }]
    });
    form.addButton('change', 'Change', function(_form) {
        var docSubType = form.getVal('reportType');
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('documentSubType', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({ document_sub_type: docSubType }),
            success: function(data) {
                var oldSubType = doc.getDocumentSubType();
                doc.setDocumentSubType(docSubType);

                var entitySet = el8.ptdata.getEntitySet(doc.getModelClass());
                if (entitySet) { entitySet.trigger(EVENTS.MOVED, doc, oldSubType); }

                that.hide();
            }
        });

    }, true);
    form.addCancelButton(function(_form) {
        that.hide();
    }, false);
    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        el8.data.reportTypes.softLoad();
        super_init.call(that);
    };

    var super_show = that.show;
    that.show = function(_doc) {
        doc = _doc;
        super_show.call(that);

        updateReportTypeSelect();
    };

    function updateReportTypeSelect() {
        var selectOpts = el8.data.reportTypes.sorted().map(function(rType) {
            return { id: rType.getId(), value: rType.getClientReportTypeKey(), description: rType.getUserLabel() };
        });
        var selectList = [];
        for( var i=0; i<selectOpts.length; i++ ) {
            if(doc.getDocumentSubType() !== selectOpts[i].id) {
                selectList.push(selectOpts[i]);
            }
        }
        $('.select-box', that.getContentElt()).html(
            el8.template.appchart.dialog.changeReportCategory.select({list: selectList})
        );
        that.adjustHeight();
    }

    return that;

})();
